import { motion } from "framer-motion";
import { GALLERY } from "@/data/content";

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="bg-cafe py-28 md:py-40">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1 }}
          className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end"
        >
          <div>
            <p className="mb-6 font-body text-xs uppercase tracking-[0.35em] text-accent">The Space</p>
            <h2 className="font-display text-4xl leading-tight tracking-tight text-[var(--text)] sm:text-5xl lg:text-6xl">
              Come sit a while.
            </h2>
          </div>
          <p className="max-w-sm font-serif-c text-xl italic text-[var(--text)]/60">
            Good coffee, a warm welcome and a pool table out the back. Pull up a chair and stay a while.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={g.label}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: [0.19, 1, 0.22, 1], delay: i * 0.1 }}
              className={`group relative overflow-hidden ${i % 2 === 1 ? "lg:mt-12" : ""}`}
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={g.src}
                  alt={g.label}
                  style={{
                    objectPosition: g.pos || "center",
                    clipPath: g.clipTop ? `inset(${g.clipTop} 0 0 0)` : undefined,
                  }}
                  className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-70 transition-opacity duration-500 group-hover:opacity-90" />
              <figcaption className="absolute bottom-5 left-5">
                <p className="font-serif-c text-2xl text-[var(--text)]">{g.label}</p>
                <p className="font-body text-xs uppercase tracking-[0.2em] text-[var(--text)]/60">{g.caption}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
